import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Form, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { DrawerComponent } from "../UI/Drawer/DrawerComponent";
import ErrorAlert from "../UI/ErrorAlert/ErrorAlert";
import { getLocalStorage } from "../../helpers/utils";
import ChangePasswordForm from "./ChangePasswordForm";
import EditProfileForm from "./EditProfileForm";
import "./HeadbarDrawerStyles.scss";

const HeaderDrawer = ({
  drawerVisible,
  onClose,
  editProfileDrawer,
  handleChangePasswordOnClick,
  setEditProfileDrawer,
}) => {
  const { editProfileError } = useSelector(
    (state) => state.editEmployeeProfile
  );
  const [form] = Form.useForm();
  const userData = getLocalStorage("USER_DETAILS");

  useEffect(() => {
    form.setFieldsValue({
      name: userData?.user_name ? userData?.user_name : userData?.name,
      orgName: userData?.organization,
      department: userData?.department,
      emailID: userData?.user_email ? userData?.user_email : userData?.email,
    });
  }, []);

  const onCancel = () => {
    onClose();
    setEditProfileDrawer(false);
  };

  return (
    <DrawerComponent
      content={
        <>
          <div className="drawer-wrapper">
            <div className="drawer-title">
              {editProfileDrawer ? "Edit Profile" : "Change Password"}
            </div>
            <div className="drawer-description">
              {editProfileDrawer
                ? "Fill the following fields to edit your profile."
                : "Fill in the new password to change password"}
            </div>
            <div className="form-progress"></div>
          </div>
          <ErrorAlert errorData={editProfileError} />
          {editProfileDrawer && (
            <div className="avatar-container-drawer">
              <Avatar size={160} icon={<UserOutlined />} />
            </div>
          )}
          {editProfileDrawer ? (
            <EditProfileForm
              form={form}
              onCancel={onCancel}
              handleChangePasswordOnClick={handleChangePasswordOnClick}
            />
          ) : (
            <ChangePasswordForm onCancel={onCancel} />
          )}
        </>
      }
      drawerVisible={drawerVisible}
      onClose={onClose}
    />
  );
};

export default HeaderDrawer;
